export default "__VITE_ASSET__s1RU6Erg__"